import classNames from 'classnames';
export const getFilteredValues = (query, values) => {
    return query === ''
        ? values
        : values.filter((value) => value.label
            .toLowerCase()
            .replace(/\s+/g, '')
            .includes(query.toLowerCase().replace(/\s+/g, '')));
};
export const getWrapperClasses = (labelDirection, customClassName) => classNames(`relative flex gap-1 items-baseline w-full`, {
    'flex-col': labelDirection === 'col',
    'flex-row': labelDirection === 'row'
}, customClassName);
export const getLabelClassName = (disabled, size, customClassName) => classNames('min-w-[120px] font-semibold', disabled ? 'text-gray' : 'text-gray-700', {
    'text-mBase md:text-base': !size,
    'text-sm': size === 'sm',
    'text-base': size === 'md',
    'text-mBase': size === 'lg'
}, customClassName);
export const getIconClasses = (size) => classNames({
    'w-6 h-6 md:w-5 md:h-5': !size,
    'w-4 h-4': size === 'sm',
    'w-5 h-5': size === 'md',
    'w-6 h-6': size === 'lg'
});
export const getArrowIconClasses = (size, isPostIcon) => classNames(getIconClasses(size) + ' text-gray', isPostIcon
    ? {
        'right-8 md:right-9': !size,
        'right-8': size === 'sm',
        'right-9': size === 'md',
        'right-10': size === 'lg'
    }
    : 'right-3');
export const getPostIconClasses = (size, errors, isSuccess) => classNames(getIconClasses(size), 'right-3', errors ? 'text-red' : isSuccess ? 'text-green' : 'text-gray');
export const getInputClasses = (size, preIcon, errors, isSuccess, isPostIcon, hasAvatar) => classNames('w-full outline-none ring-1 !ring-inset border-none rounded-md placeholder-gray text-gray-700 disabled:ring-gray200 disabled:bg-gray-200 focus:shadow-none focus:ring-2 focus:ring-blue truncate', {
    'bg-green-50': isSuccess
}, {
    'py-[13px] text-mBase md:py-[9px] md:text-base': !size,
    'py-[7.5px] text-sm': size === 'sm',
    'py-[9px] text-base': size === 'md',
    'py-[13px] text-mBase': size === 'lg',
    'font-bold': hasAvatar
}, isPostIcon
    ? {
        'pr-12 md:pr-14': !size,
        'pr-12': size === 'sm',
        'pr-14': size === 'md',
        'pr-16': size === 'lg'
    }
    : {
        'pr-10 md:pr-9': !size,
        'pr-8': size === 'sm',
        'pr-9': size === 'md',
        'pr-10': size === 'lg'
    }, preIcon || hasAvatar
    ? {
        'pl-10 md:pl-9': !size,
        'pl-8': size === 'sm',
        'pl-9': size === 'md',
        'pl-10': size === 'lg'
    }
    : 'pl-3', !errors ? 'ring-gray-400 shadow-sm' : 'ring-2 ring-red shadow-none');
export const getCheckIconClasses = (size) => classNames('text-blue group-hover:text-white', {
    'w-6 h-6 md:w-5 h-5': !size,
    'w-4 h-4': size === 'sm',
    'w-5 h-5': size === 'md',
    'w-6 h-6': size === 'lg'
});
export const getHelperClasses = (size, errors) => classNames('mt-2', {
    'text-base md:text-sm': !size,
    'text-xs': size === 'sm',
    'text-sm': size === 'md',
    'text-base': size === 'lg'
}, !!errors ? 'text-red' : 'text-gray');
export const getOptionLabelClasses = (selected, hasAvatar) => {
    return classNames('block truncate', {
        'font-semibold': (selected && !hasAvatar) || (hasAvatar && !selected),
        'font-bold': hasAvatar && selected
    });
};
